module.exports = __webpack_public_path__ + "static/media/passeio.26ee7d93.svg";